import React, { useState } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.css";
import { StylesProvider } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux";
// eslint-disable-next-line no-unused-vars
import { AuthorizationHandler, PopupManager } from "./providers";
import ClientSelector from "./components/ClientSelector/ClientSelector";
import StorageService from "./utils/storageService";

function Root() {
  const [clientId, setClientId] = useState(StorageService.getItem("clientId"));

  if (!clientId) {
    return <ClientSelector onSelect={setClientId} />;
  }

  return (
    <StylesProvider injectFirst>
      <Provider store={store}>
        <PopupManager>
          <AuthorizationHandler>
            <Router>
              <App />
            </Router>
          </AuthorizationHandler>
        </PopupManager>
      </Provider>
    </StylesProvider>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
